import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isFeatureEnabled } from '../helpers/feature-utils';

import {
  IBrandFeatures,
  IFeature,
  IFeatureMap,
} from '../models/feature.interfaces';
import { APP_FEATURES } from '../models';

/**
 * Feature service used to provide the available features.
 * At the moment, it loads from a hardcoded file, but is necessary so we can:
 *  - Mock the features on unit testing
 *  - Extend the solution to fetch data from backend in the future
 *
 * @export
 * @class FeatureService
 */
@Injectable({ providedIn: 'root' })
export class FeatureService {
  constructor(@Inject(APP_FEATURES) private features: IFeatureMap[]) {}

  getFeatures(brand: string, stage: string): Observable<IBrandFeatures> {
    const brandFeatures = this.features.reduce<IBrandFeatures>((acc, item) => {
      const feature: IFeature = {
        id: item.id,
        name: item.name,
        enabled: isFeatureEnabled(item.enabled, brand, stage),
      };
      acc[item.id] = feature;
      return acc;
    }, {});

    return of(brandFeatures);
  }
}
